/*
  Simulador de Frete Shopify - Refatorado e Blindado
  Garante que o cookie de carrinho original seja preservado sob qualquer cenário.
*/
(function () {

    "use strict";

    var debug = false;
    var shippingCalculationRunning = false; // Lock para evitar concorrência (2 cliques rápidos)

    function log(text) {
        if (debug) console.log(text);
    }

    /* O elemento que recebe o box de cálculo */
    var productSection = document.getElementsByClassName('frete-produto');
    if (!productSection.length) { log('Could not find the element'); return; }

    /* O select principal de variantes */
    var productSelect = document.getElementById('ProductSelect-product-template');
    if (!productSelect) {
        var productForm = document.querySelector('.productView-moreItem form');
        if (productForm) {
            productSelect = productForm.querySelector('select[name="id"]') || productForm.querySelector('input[name="id"]') || null;
        }
    }
    if (!productSelect) { productSelect = document.getElementsByName('id')[0]; }
    if (!productSelect) { log('Could not find the main select element'); return; }

    var shippingMessage = document.createElement('p');
    var shippingCountry = document.createElement('select');
    var shippingProvince = document.createElement('select');
    var shippingZip = document.createElement('input');
    var freteLista = document.createElement('div');

    /* Setup dos containers de erro e lista de fretes */
    shippingMessage.classList.add('erros-fretes');
    shippingMessage.setAttribute("style", "display:none");

    freteLista.classList.add('listas-de-fretes');
    freteLista.setAttribute("style", "display:none");

    var getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    };

    var updateCartCookie = function (value) {
        log('Changing cart cookie value to: ' + value);
        var date = new Date();
        date.setTime(date.getTime() + (14 * 86400000));
        var expires = '; expires=' + date.toGMTString();
        document.cookie = 'cart=' + value + expires + '; path=/';
    };

    var deleteCartCookie = function() {
        document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    };

    var initFields = function () {
        /* Configurando País (Fixo Brasil) */
        shippingCountry.id = "pais-simulator";
        shippingCountry.add(new Option('Brazil', 'Brazil', true));
        shippingCountry.name = 'shipping_address[country]';
        shippingCountry.style.display = 'none'; // Pode ocultar já que é fixo, opcional

        /* Configurando Estados */
        shippingProvince.id = "estados-simulator";
        var provinces = ['Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'];
        for (var i = 0; i < provinces.length; i++) {
            shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
        };
        shippingProvince.name = 'shipping_address[province]';

        /* Configurando o campo CEP */
        shippingZip.type = 'text';
        shippingZip.name = 'shipping_address[zip]';
        shippingZip.className = 'Form__Input cep-calculo-frete form-control';
        shippingZip.placeholder = 'CEP';

        var shippingCalcWrapper = document.createElement('div');
        shippingCalcWrapper.className = 'shipping-calc-wrapper';

        var formularioFrete = document.createElement('div');
        formularioFrete.className = 'formulario-frete';

        var shippingCalcButton = document.createElement('a');
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.className = 'btn btn-underline button--primary button';
        
        shippingCalcButton.onclick = function () {
            if (shippingCalculationRunning) return; // Impede execução simultânea via UI

            var cepLimpo = shippingZip.value.replace(/\D/g, '');
            if(cepLimpo.length !== 8) {
                shippingMessage.innerHTML = 'Insira um CEP válido com 8 dígitos.';
                shippingMessage.setAttribute("style", "display:flex");
                return;
            }

            shippingMessage.innerHTML = '';
            shippingMessage.setAttribute("style", "display:none");

            // Busca UF via CEP primeiro
            $.getJSON("https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?", function (dados) {
                if (!("erro" in dados)) {
                    var mapUF = {
                        'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapa', 'AM': 'Amazonas', 'BA': 'Bahia', 
                        'CE': 'Ceara', 'DF': 'Distrito Federal', 'ES': 'Espirito Santo', 'GO': 'Goias', 
                        'MA': 'Maranhao', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul', 'MG': 'Minas Gerais', 
                        'PA': 'Para', 'PB': 'Paraiba', 'PR': 'Parana', 'PE': 'Pernambuco', 'PI': 'Piaui', 
                        'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte', 'RS': 'Rio Grande do Sul', 
                        'RO': 'Rondonia', 'RR': 'Roraima', 'SC': 'Santa Catarina', 'SP': 'Sao Paulo', 
                        'SE': 'Sergipe', 'TO': 'Tocantins'
                    };
                    shippingProvince.value = mapUF[dados.uf] || dados.uf;

                    var variantId = !productSelect.value.length ? 
                        parseInt($(productSelect).find('option').get(1).value) : 
                        parseInt(productSelect.value);

                    // Chama a função assíncrona principal
                    getRates(variantId);
                } else {
                    mostrarErroCep();
                }
            }).fail(mostrarErroCep);
        };

        function mostrarErroCep() {
            $('.listas-de-fretes').html("");
            shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
            shippingMessage.setAttribute("style", "display:flex");
        }

        formularioFrete.appendChild(shippingCountry);
        formularioFrete.appendChild(shippingProvince);
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);
        
        shippingCalcWrapper.appendChild(formularioFrete);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);

        productSection[0].appendChild(shippingCalcWrapper);
    };

    function isDateBeforeToday(date) {
        return new Date(date.toDateString()) < new Date(new Date().toDateString());
    }

    function excludeDate(name) {
        return (name !== 'Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis' && 
                name !== 'Entrega Rápida - pedidos chegam em até 48hrs úteis');
    }

    async function getRates(variantId) {
        if (!variantId) return;

        // 1. Lock - Impede duas execuções simultâneas
        if (shippingCalculationRunning) return;
        shippingCalculationRunning = true;

        // 2. Salvar o cookie original uma ÚNICA vez no início
        const originalCartCookie = getCookie('cart');
        let cookieChanged = false;

        // Preparação Visual
        $('.listas-de-fretes').html("<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif' style='width:30px; height: 30px; margin:0 auto; display:block;'>");
        $('.listas-de-fretes').show();

        // 3. Timeout de Segurança ("Airbag") - Caso uma request trave pra sempre
        const restoreTimer = setTimeout(() => {
            log('Timeout de segurança ativado.');
            if (cookieChanged) {
                if (originalCartCookie) updateCartCookie(originalCartCookie);
                else deleteCartCookie();
            }
            shippingCalculationRunning = false;
        }, 15000); // 15 segundos max

        try {
            // Cria um ID temporário aleatório para o carrinho
            const fakeCookieValue = "fake-cart-cookie___" + Date.now();
            
            // Substitui o cookie atual
            updateCartCookie(fakeCookieValue);
            cookieChanged = true; 

            var productQuantity = document.getElementById('Quantity');
            var quantity = productQuantity ? parseInt(productQuantity.value) : 1;

            // Passo 1: Adiciona item no carrinho falso
            const addResponse = await fetch('/cart/add.js?_easygift_internal=true', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                body: JSON.stringify({ id: variantId, quantity: quantity })
            });

            if (!addResponse.ok) throw new Error("Falha ao adicionar item no carrinho temporário.");

            // Passo 2: Busca os valores de frete
            const params = new URLSearchParams({
                'shipping_address[country]': shippingCountry.value,
                'shipping_address[province]': shippingProvince.value,
                'shipping_address[zip]': shippingZip.value,
                '_easygift_internal': 'true'
            });

            const ratesResponse = await fetch('/cart/shipping_rates.json?' + params.toString(), {
                method: 'GET',
                headers: { 'X-Requested-With': 'xmlhttprequest' }
            });

            if (!ratesResponse.ok) throw new Error("Falha ao consultar opções de frete.");
            
            const ratesData = await ratesResponse.json();

            $('.listas-de-fretes').html(''); // limpa o loader

            if (ratesData.shipping_rates && ratesData.shipping_rates.length) {
                ratesData.shipping_rates.forEach(function(rate) {
                    var entregaData = new Date(rate.delivery_date);
                    var checkBeforeday = isDateBeforeToday(entregaData);
                    var excludeDateCheck = excludeDate(rate.name);
                    let dataFormatada = entregaData.getDate() + "/" + (entregaData.getMonth() + 1) + "/" + entregaData.getFullYear();
                    
                    var valorFrete = rate.price;
                    if (valorFrete == "0.00" || valorFrete == null) { 
                        valorFrete = "Grátis";
                    } else { 
                        // Assumindo que a loja possui o Shopify.formatMoney carregado
                        valorFrete = typeof Shopify !== 'undefined' && Shopify.formatMoney ? 
                                     Shopify.formatMoney(valorFrete, 'R$ {{amount_no_decimals_with_comma_separator}}') : 
                                     'R$ ' + valorFrete; 
                    }

                    var textoEntrega = "";
                    if (rate.delivery_date == null && excludeDateCheck || checkBeforeday && excludeDateCheck) {
                        textoEntrega = "Estimativa de entrega indisponível";
                    } else if (!excludeDateCheck) {
                        textoEntrega = ""; // Mantem regra original (vazio nestes casos específicos)
                    } else {
                        textoEntrega = "(Estimativa de entrega: " + dataFormatada + ")";
                    }

                    $('<div class="frete-item"> <div> <p class="m-0 nome-frete"><b>' + rate.name + '</b> <span class="estimativa-de-entrega">' + textoEntrega + '</span></p> </div><div class="frete-valor">Valor: <b> ' + valorFrete + '</b></div> </div>').appendTo('.listas-de-fretes');
                });
            } else {
                shippingMessage.innerHTML = 'Nenhuma opção de frete encontrada para este CEP.';
                shippingMessage.style.display = "flex";
            }

        } catch (error) {
            console.error("Erro durante calculo de frete: ", error);
            $('.listas-de-fretes').html("");
            shippingMessage.innerHTML = 'Erro de conexão ao calcular o frete.';
            shippingMessage.style.display = "flex";

        } finally {
            clearTimeout(restoreTimer); // Cancela o "Airbag"
            
            if (cookieChanged) {
                if (originalCartCookie) {
                    // Restaura exatamente a string que havia antes
                    updateCartCookie(originalCartCookie);
                } else {
                    // Caso o usuário não tivesse cookie de cart antes, limpamos o falso
                    deleteCartCookie();
                }
            }
            
            // Libera a trava para o próximo clique
            shippingCalculationRunning = false;
            log('Execução finalizada, carrinho original restabelecido.');
        }
    };

    /* Inicializa o front-end */
    initFields();

})();